import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import ServiceGrid from '../components/ServiceGrid';
import HierarchySection from '../components/HierarchySection';

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <ServiceGrid />
      <HierarchySection />
    </>
  );
};

export default Home;

